export interface ICompanyConfigResponse {
  steps: string[],
  requiredFields: string[]
}

export default class CompanyDataResponse implements ICompanyConfigResponse {
  steps: string[];
  requiredFields: string[];

  constructor() {
      this.steps = [];
      this.requiredFields = [];
  }
}

export const QUESTIONID = {
  companyLegalName: 129,
  companyDoingBusinessAs: 130,
  companyParentCompany: 128,
  companyWebsite: 133,
  companyPhoneNumber: 134,
  companyEmailAddress: 136,
  companyTaxIdNumber: 131,
  dunsNumber: 132,
  primaryNAICSCode: 137,
  secondaryNAICSCode: 138,
  yearCompanyWasFounded: 127,
  numberOfPermanentEmployees: 126,
  unionizedCompany: 125,
  supplierCompanyOwnership: 109
}

interface IAnnualSale {
  [key: number]: number
}

export const ANNUAL_SALE: IAnnualSale = {
  2017: 654,
  2018: 655,
  2019: 656,
  2020: 665,
  2021: 666,
  2022: 667,
  2023: 668,
  2024: 669,
  2025: 670,
  2026: 671,
  2027: 672,
  2028: 673,
  2029: 674,
  2030: 675
};

export const variableSteps = ["BusinessInfo", "Diversity", "Products"];

